import { render } from "./loginBox.vue?vue&type=template&id=47ed7936"
import script from "./loginBox.vue?vue&type=script&lang=js"
export * from "./loginBox.vue?vue&type=script&lang=js"

import "./loginBox.vue?vue&type=style&index=0&id=47ed7936&lang=less"

import exportComponent from "/root/.jenkins/workspace/embeddedJobWebProd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__